<template>
    <div class="insurance-target-card">
        <span class="insurance-target-card__icon">
            <SvgIcon class="insurance-target-card__icon-pic"
            :name="iconName"
            size="medium" />
        </span>

        <p class="insurance-target-card__text" v-html="textHtml" />

    </div>
</template>

<script>
import SvgIcon from '@/components/ui/SvgIcon';

export default {
    name: 'InsuranceTargetCard',
    components: {
        SvgIcon
    },
    props: {
        textHtml: {
            type: String,
            required: true
        },
        iconName: {
            type: String,
            required: true
        }
    },
}
</script>

<style scoped lang="scss">
.insurance-target-card {
    line-height: 0;

    height: 100%;
    padding: rem($gap-medium);

    border-radius: rem($border-radius-default);
    background-color: $color-card-background-primary;

    &__icon {
        display: inline-block;
        
        padding: rem($gap-mini);
        
        border-radius: rem($border-radius-tiny);
        background-color: $primary;
        
        &-pic {
            color: $primary;
        }
    }

    &__text {
        @include text-average($font-weight-medium);

        margin-top: rem($gap-medium);

        
        font-size: rem($font-size-normal);
        
    }
}
</style>